<template>
  <div class="content">
    <s-location apply title="오사용 증표 정정 신청" />

    <!-- //검색창 -->
    <div class="flow_wrap arr">
      <li  class="on">
        <b>01</b> 오사용 증표 <br class="mobile" />정정 신청
      </li>
      <li class="arr"></li>
      <li >
        <b>02</b> 정정 신청 <br class="mobile" />접수
      </li>
      <li class="arr"></li>
      <li>
        <b>03</b>등록된 계좌로 환급<br class="mobile" /><small>(접수 후 2주이내)</small>
      </li>
    </div>
    <!--  주의사항  -->
    <div class="comment_gray expcomment mt_15 ">
      <p class="tit">오사용 증표 정정 신청 안내</p>
      <p>소송위임장 등에 경유확인서를 첨부하여 법원 등에 제출하였으나,<br class="mobile" /> 추후 사건유형이 잘못된 것이 확인되어 이를 정정하고자 할 경우에 해당합니다.</p>
      <div class="mbtn">예시 보기 </div>
      <p class="b mt30 mb10 al_c" >- 예 시 -</p>
      <ol>
        <li>본안(일반)사건에 신청사건 경유증표를 사용한 경우</li>
        <li>신청사건에 본안(일반)사건 경유증표를 사용한 경우</li>
        <li>본안(일반)사건에 본안(민사고액)사건 경유증표를 사용한 경우</li>
        <li>이와 유사하게 경유증표를 잘못 사용한 경우</li>
        <p class="mt15">※ 본안(일반)사건에서 본안(민사소액)사건으로 변경하여 환불 신청하는 경우 소가를 확인할 수 있는 내역을 첨부해 주시기 바랍니다.</p>
      </ol>
    </div>

    <div class="btn_group">
      <div class="right">
        <button @click="initData" class="btn icon reload">초기화</button>
        <button @click="doSearch" class="btn icon search_black">검색</button>
      </div>
    </div>

    <!-- 검색조건 -->
    <table class="tbl01 sch_tbl">
      <tr>
        <th>사용일</th>
        <td>
          <i-input-date input-class="w_inputno" title="시작일" v-model="search.iv_viadtfr" :placeholder="search.iv_viadtfr"/>
        ~ <i-input-date input-class="w_inputno" title="종료일" v-model="search.iv_viadtto" :placeholder="search.iv_viadtto"/>
        <br class="mobile"/>
          <s-date-range :fr.sync="search.iv_viadtfr" :to.sync="search.iv_viadtto" />
        </td>
      </tr>
      <tr>
        <th>증표 종류</th>
        <td>
          <c증표종류_검색폼
            :search.sync="search"
            :except_code="except_code"
            @select="doSearch"
          />
        </td>
      </tr>
      <tr>
        <th>증표 번호</th>
        <td>
            <input type="text" v-model="search.iv_rcptnofr_1" class="w_inputno" placeholder="증표번호 FROM" @keyup.enter="doSearch"/> -
            <input type="text" v-model="search.iv_rcptnoto_1" class="w_inputno" placeholder="증표번호 TO" @keyup.enter="doSearch"/>
        </td>
      </tr>
      <tr>
        <th>관할기관</th>
        <td>
            <input type="text" v-model="search.iv_isttoutplac" class="sch_input" placeholder="관할기관" @keyup.enter="doSearch"/>
        </td>
      </tr>
      <tr>
        <th>검색어</th>
        <td>
          <select v-model="search.iv_ktype">
            <option value="ALL"      >전체</option>
            <option value="MEMBNM"   >증표명의</option>
            <option value="CLIENT"   >위임인</option>
            <option value="OTHERSIDE">상대방</option>
            <option value="REMK"     >비고</option>
          </select>
          <input type="text" class="sch_input" title="검색어" v-model="search.iv_kword" placeholder="검색어" @keyup.enter="doSearch"/>
        </td>
      </tr>
    </table>

    <h4 class="sub_title02">검색 결과</h4>

    <s-loading v-if="list.loading"/>
    <div class="scroll_wrap"> <!--모바일 스크롤 -->
      <p class="scroll_txt"> &lt;-&gt; 좌우 스크롤을 이용하세요</p>
      <!-- 테이블 -->
      <table class="tbl01 thin">
        <thead>
          <tr>
            <th class="no">순번</th>
            <th class="date">구입일자</th>
            <th class="viakind">증표종류</th>
            <th>증표번호</th>
            <th>경유일자</th>
            <th>관할기관</th>
            <th>사건명</th>
            <th class="vianame">위임인 구분</th>
            <th class="vianame">위임인</th>
            <th class="vianame">상대방</th>
            <th>수임일자</th>
            <th width="40px">사건<br/>유형</th>
            <th>사건번호</th>
            <th>비고</th>
            <th class="no">추가</th>
          </tr>
        </thead>
        <tr v-for="(item,i) in list.items" :key=i :class="{ 'bg_gray01' : !showPlusBtn(item) }">
          <td>{{ list.totalCount - ((list.pageNo -1) * list.listSize) - i }}</td>
          <td>{{ item.selldt | moment('YYYY.MM.DD') }}</td>
          <td>{{ item.org_caseclsfnm  }}</td>
          <td>{{ item.rcptno | insertHyphen(5) }}</td>
          <td>{{ item.viadt | moment('YYYY.MM.DD') }}</td>
          <td>{{ item.isttoutplac  }}</td>
          <td>{{ item.casenm  }}</td>
          <td>{{ item.clientclsf }}</td>
          <td>{{ item.client }}</td>
          <td>{{ item.otherside  }}</td>
          <td>{{ item.cntchargdt | moment('YYYY.MM.DD') }}</td>
          <td>{{ item.casetypenm  }}</td>
          <td>{{ item.caseno  }}</td>
          <td>{{ item.remk  }}</td>
          <td class="p0">
            <img v-if="showPlusBtn(item)"
                 src="/images/common/icon_plus_blue.png"
                 class="icon_squ"
                 @click="addRow(item)"
                 > <!-- 본안, 등기, 신청, 민사소액, 고액만 가능 -->
          </td>
        </tr>
      </table>
     <!-- //테이블 -->
     </div> <!--// scroll_wrap -->
    <!-- paging -->
     <div class="paging">
      <p class="num">
          <s-page :pageNo.sync="list.pageNo" :totalCount="list.totalCount" :listSize="list.listSize" @changePage="doSearch"/>
      </p>
    </div>
    <!-- /paging -->
    <!--           </form> -->

    <!-- 변경신청 할 사건현황 -->
    <h4 class="sub_title02">변경 신청할 사건 현황</h4>

    <div class="scroll_wrap"> <!--모바일 스크롤 -->
      <p class="scroll_txt"> &lt;-&gt; 좌우 스크롤을 이용하세요</p>

      <table class="tbl01 ">
        <thead>
          <tr>
            <th class="no">순번</th>
            <th class="date">구입일자</th>
            <th class="viakind">증표종류</th>
            <th>증표번호</th>
            <th class="date">경유일자</th>
            <th>관할기관</th>
            <th>사건명</th>
            <th class="vianame">위임인</th>
            <th class="vianame">상대방</th>
            <th>수임일자</th>
            <th width="40px">
              사건
              <br />유형
            </th>
            <th>사건번호</th>
            <!-- <th class="td_org01 vianame">담당변호사</th> -->
            <th class=" btn01">비고</th>
            <th>제거</th>
          </tr>
        </thead>

        <tr v-for="(item,i) in saveList" :key=i>
          <td>{{ i + 1 }}</td>
          <td>{{ item.selldt | moment('YYYY.MM.DD') }}</td>
          <td>{{ item.org_caseclsfnm  }}</td>
          <td>{{ item.rcptno | insertHyphen(5) }}</td>
          <td>{{ item.viadt | moment('YYYY.MM.DD') }}</td>
          <td>{{ item.isttoutplac  }}</td>
          <td>{{ item.casenm  }}</td>
          <td>{{ item.client  }}</td>
          <td>{{ item.otherside  }}</td>
          <td>{{ item.cntchargdt | moment('YYYY.MM.DD') }}</td>
          <td>{{ item.casetypenm  }}</td>
          <td>{{ item.caseno  }}</td>
          <!-- <td class="td_gray01">{{ item.membnms  }}</td> -->
          <td >{{ item.remk  }}</td>
          <td class="p0">
            <img src="/images/common/icon_minus_org.png"
                class="icon_squ"
                @click="delRow(item)">
          </td>
        </tr>
      </table>
     </div> <!--// scroll_wrap -->

    <!-- //변경신청 할 사건현황 -->

    <!-- paging -->
    <div class="paging">
      <p class="num">
        <!-- <d:showNavi skin="front" pageNo="${ pageNo }" totalCount="${ listTotCnt }" listSize="${ listSize }" />  -->
      </p>
    </div>
    <!-- /paging -->
    <!-- //변경신청 할 사건현황 -->
    <!-- 변경내용 -->
    <h4 class="sub_title02">변경내용</h4>

    <!-- 테이블 -->
    <table class="tbl01 sum">
      <tr>
        <th class="al_t">변경 전<br class="mobile"/> 경유증표</th>
        <td>
          <input type="text" v-model="sitem.org_caseclsfnm" disabled="disabled" />
           {{ sitem.org_viafee | comma }}
        </td>
      </tr>
      <tr>
        <th class="al_t">변경 후<br class="mobile"/> 경유증표</th>
        <td>
          <select v-model="sitem.to_caseclsf" class="point01" @change="calAmt()">
            <option value="" selected="selected">선택</option>
            <!-- 변경전 경유증표 빼고 조회 ( 면제(B10400)는 N_UPRC_LIST 의 menu 가 front 일때 자동으로 제외되어 넘어옴 -->
            <option v-for="prod in (prods && prods.filter(prod=> prod.caseclsf != sitem.caseclsf))"
                    :value="prod.caseclsf"
                    :key="prod.caseclsf">{{prod.name}}</option>
          </select>
          <!-- 본안으로 변경할 경우 사건 유형 선택 가능하도록 -->
          <select v-if="sitem.to_caseclsf == 'B10100'"
            v-model="sitem.to_casetype">
            <option value="" selected="selected">선택</option>
            <option v-for="item in code[sitem.to_caseclsf]"
              :value="item.value"
              :key="item.value">{{item.text}}</option>
            >
          </select>
          {{ sitem.to_viafee | comma }}
        </td>
      </tr>
      <tr>
        <th class="al_t" width="144px">차액금</th>
        <td>
          {{ sitem.to_amt | absComma }}
          <span v-if="sitem.to_amt > 0">(입금금액)</span>
          <span v-if="sitem.to_amt < 0">(환불금액)</span>
        </td>
      </tr>
      <tr>
        <th>정정 사유</th>
          <td class="al_l input_etc">
          <select v-model="sitem.reasonclsf">
             <option value="" selected="selected">선택</option>
             <option v-for="item in code.RCH_CASE"
                    :value="item.value"
                    :key="item.value">{{item.text}}</option>
           </select>
           <input type="text"
                  v-model="sitem.reasonremk"
                  v-if="sitem.reasonclsf == 'ETC'"
                  placeholder="기타사유"
                  />
        </td>
      </tr>
    </table>
    <table class="tbl01 sum" v-if="sitem.to_amt > 0">
       <tr>
        <th>입금 모계좌번호</th>
        <td>{{ T.codeText(code.CONFIG, '모계좌') }}</td>
       </tr>
    </table>

    <table class="tbl01 sum" v-if="sitem.to_amt < 0">
      <tr>
        <th class="al_t">환불 금액</th>
        <td class="infoamt">
          {{ sitem.rf_amt | comma }} 원
          <span class="red01 right"><b>환불금액은 증표명의자의 계좌로만 입금 가능합니다.</b></span>
        </td>
      </tr>
      <tr>
        <th class="al_t">은행명</th>
        <td class="infoamt bankinfo_wrap">
          <li clas="bankinfo_th">
            <select v-model="sitem.rfbankcode">
             <option value="" selected="selected">선택</option>
             <option v-for="item in code.BANKCODE"
                    :value="item.value"
                    :key="item.value">{{item.text}}</option>
            </select>
          </li>
          <div class="bankinfo">
            <li>
              <span>환불 계좌번호 </span>
              <input type="text" v-model="sitem.rfaccno" class="mt5" placeholder="000-00-00000">
            </li>
            <li><span>예금주</span> <input type="text" v-model="sitem.rfaccname" class="mt5"></li>
          </div>
        </td>
      </tr>
      <tr>
        <th class="al_t">통장사본(첨부파일)</th>
        <td class="infoamt">

          <i-fileupload name="file1" ref="file1" v-model="file1"
            :action="$api + '/attach'"
            autoUpload required
            kind="bankauth"
            :exts="'jpeg,jpe,jpg,gif,png,pdf'.split(/,/)"
            @done="file=>sitem.attachid = file.uuid"
            >

            <template v-slot:dropArea="{isDropActive, files}">
              <div v-if="$mq != 'mobile' && !file1.name" class="file_drag" :style="{ 'background-color': isDropActive ? 'green' : 'gray' }">
                Drag And Drop
              </div>
            </template>

            <template v-slot:uploadFile="{file, remove}">
              {{ file.name }} ( 용량 : {{ file.size | comma }} byte )
              <i-btn class="btn" @click.prevent="remove(file);sitem.attachid=null" :key="file.id">취소</i-btn>
            </template>

            <button v-if="!file1 || !file1.name"
              class="btn gray01 outline btn_filesel">
              파일선택
            </button>

            &nbsp;
          </i-fileupload>
          <div class="mt10">
            ※ 통장 실물이 없는 경우 계좌개설확인서를 첨부해 주세요. (jpg,gif,png,pdf)
          </div>
        </td>
      </tr>

      <tr>
        <!-- 본안(일반-B10100)에서 본안(민사소액-B10600)으로 신청하는 경우 -->
        <th class="al_t" v-if="sitem.caseclsf == 'B10100' && sitem.to_caseclsf == 'B10600'">소가 확인 내역</th>
        <th class="al_t" v-else>위임장 사본 또는 <br/>나의사건검색 화면</th>
        <td class="infoamt">

          <i-fileupload name="file2" ref="file2" v-model="file2"
            :action="$api + '/attach'"
            autoUpload required
            kind="bankauth"
            :exts="'jpeg,jpe,jpg,gif,png,pdf'.split(/,/)"
            @done="file=>sitem.attachid2 = file.uuid"
            >

            <template v-slot:dropArea="{isDropActive, files}">
              <div v-if="$mq != 'mobile' && !file2.name" class="file_drag" :style="{ 'background-color': isDropActive ? 'green' : 'gray' }">
                Drag And Drop
              </div>
            </template>

            <template v-slot:uploadFile="{file, remove}">
              {{ file.name }} ( 용량 : {{ file.size | comma }} byte )
              <i-btn class="btn" @click.prevent="remove(file);sitem.attachid2=null" :key="file.id">취소</i-btn>
            </template>

            <button v-if="!file2 || !file2.name"
              class="btn gray01 outline btn_filesel">
              파일선택
            </button>

            &nbsp;
          </i-fileupload>
          <div class="mt10">
            <span v-if="sitem.caseclsf == 'B10100' && sitem.to_caseclsf == 'B10600'">※ 대법원 나의사건보기에 소가가 표기된 부분을 캡쳐하여 첨부해 주세요. (jpg,gif,png,pdf)</span>
            <span v-else>※ 위임장 사본 또는 나의사건검색 화면 사진파일을 캡쳐하여 첨부해 주세요. (jpg,gif,png,pdf)</span>
          </div>
        </td>
      </tr>
    </table>
    <!-- //테이블 -->
    <!-- //변경내용 -->
    <div class="btn_group">
      <!-- <button href="#" class="btn gray01 outline left">취소</button> -->
      <button @click="saveItem" class="btn gray01 right">신청</button>
      <!-- href="buy_ok" -->
    </div>
  </div>
  <!-- content : width=950px; -->
</template>

<script>
let ui
export default {
   components: {
    'c증표종류_검색폼' : require('@/components/c증표종류_검색폼.vue').default
  },
   data () {
    return {
      prods : null,
      search : {},
      search_init : {
        iv_menu         : 'wrong_change_req'
      , iv_viadtfr      : this.$moment().subtract(1, 'year').format("YYYY-MM-DD") // 1 년 전
      , iv_viadtto      : this.$moment().format("YYYY-MM-DD")
      , iv_statclsf     : "BC0200"     // 사용건만 출력
      , iv_viaplac      : ""
      , iv_caseclsf     : ""
      , iv_rcptnofr_1   : ""
      , iv_rcptnoto_1   : ""
      , iv_rcptnofr     : ""
      , iv_rcptnoto     : ""
      , iv_cntchargdtfr : ""
      , iv_cntchargdtto : ""
      , iv_client       : ""
      , iv_isttoutplac  : ""
      , iv_otherside    : ""
      , iv_linkyn       : ""
      , iv_lostyn       : ""
      , iv_onlineyn     : ""
      , iv_lawyernm     : ""
      , iv_membclsf     : ""
      , iv_membno       : ""
      , iv_membnm       : ""
      , iv_viamembclsf  : ""
      , iv_viamembno    : ""
      , iv_officeclsf   : ""
      , iv_officeno     : ""
      , iv_selldtfr     : ""
      , iv_selldtto     : ""
      , iv_order_by1    : ""
      , iv_order_by2    : ""
      , iv_order_by3    : ""
      , iv_order_by4    : ""
      , iv_freeclsf     : ""
      , iv_case_b10300  : ""
      , iv_ktype        : "ALL"
      , iv_kword        : ""
      , iv_cancelclsf   : ""
      , iv_searchdtgbn  : ""
      , iv_searchfr     : ""
      , iv_searchto     : ""
      },
      sitem : {},
      sitem_init : {
        reasonclsf     : ''
      , reasonremk     : ''
      , org_caseclsfnm : ''
      , to_caseclsf    : ''
      , to_casetype    : ''
      , org_caseclsf   : ''
      , to_amt         : 0
      , rf_amt         : 0
      , rfway          : 'BANK'
      , rfbankcode     : ''
      , remk           : ''
      , rfaccno        : ''
      , rfaccname      : ''
      , org_viafee     : 0
      , to_viafee      : 0
      , attachid       : '' // 첨부파일 ID
      , attachid2      : '' // 첨부파일 ID2
      },
      except_code : ['B10400', 'B10500'], // 증표종류 검색조건 : 공익(B10500), 면제(B10400) 제외
      code: {},
      chkAll : false,
      list: {
        loading: false,
        items: [],
        totalCount: 0,
        listSize : 10,
        pageNo : 1,
      },
      saveList : [],
      dayStr: ['일', '월', '화', '수', '목', '금', '토'],
      date: '2018-06-01',
      file1: {},
      file2: {},

      defaultPopperProps : {
        arrowPosition: 'start',
        arrowOffsetScaling: 1,
        popperOptions: {
          placement: 'bottom-start',
          positionFixed: true,
          // more options in https://popper.js.org
        },
      },
    }
  },
  watch : {
    '$route': 'initData',
  },
  created() {
    ui = this.$ui;
    this.search = { ...this.search_init }
    this.sitem  = { ...this.sitem_init }
    // 공통코드 로드
    ui.codeLoad("B10100, RCH_OFFICE, RCH_CASE, BANKCODE, CONFIG", code => this.code = code )
    ui.httpGet('/proc/N_UPRC_LIST', {menu: 'front'}, ret=> this.prods = ret.data.rs1)
  },
  mounted() {
    //더보기 버튼
    $('.mbtn').click( function() {
      if($(this).closest('.comment_gray').hasClass('active')) {
        $(this).closest('.comment_gray').removeClass('active');
       } else {
        $(this).closest('.comment_gray').addClass('active');
      }
    })

  },
  methods : {
    initData(){ // 현재 메뉴 다시 클릭 시
      this.search = T.deepCopy(this.search_init)
      this.sitem  = T.deepCopy(this.sitem_init)
      this.saveList = []
      this.file1 = {}; this.$refs.file1.clear()
      this.file2 = {}; this.$refs.file2.clear()
      this.doSearch()
    },
    calAmt() {

      if (this.sitem.caseclsf == this.sitem.to_caseclsf) {
        return ui.alert("변경후 증표종류는 변경전 증표종류와 다르게 선택해 주세요.")
      }

      this.sitem.to_viafee = _.get(T.findArrayItem(this.prods, "caseclsf", this.sitem.to_caseclsf), "price", -1)
      this.sitem.to_amt = this.sitem.to_viafee - this.sitem.org_viafee || 0

      // 차액금이 -인경우 환불금액도 똑같이 세팅
      if (this.sitem.to_amt < 0) {
        this.sitem.rf_amt = Math.abs(this.sitem.to_amt)
      }
    },
    addRow(item) {
      // 1건만 신청가능
      if (this.saveList.length > 0) {
        return ui.alert("1건만 선택 가능합니다.")
      }

      this.saveList.push(item)

      this.sitem.caseclsf = item.caseclsf
      this.sitem.org_caseclsfnm = item.org_caseclsfnm
      this.sitem.org_viafee = item.viafee

      if(T.isNotEmpty(this.sitem.to_caseclsf)) this.calAmt() // 변경 후 경유증표를 먼저 선택한 경우, 금액 계산 함수를 호출
    },
    delRow(item) {
      this.saveList = this.saveList.filter(e => !(e.viaregdt == item.viaregdt && e.viaseq == item.viaseq))
      this.sitem = { ...this.sitem_init}
    },
    showPlusBtn(item) {
      return !this.saveList.some(e => e.viaregdt == item.viaregdt && e.viaseq == item.viaseq)
    },
    doSearch() {
      this.search.iv_rcptnofr = this.search.iv_rcptnofr_1 + "" + this.search.iv_rcptnoto_1
      this.search.iv_rcptnoto = this.search.iv_rcptnofr

      ui.httpGetList(this.list
        , '/proc/N_VIAINFO_SEL_LIST_EMP'
        , {
          ...this.search
          , iv_statclsf    : 'BC0200' // 사용(BC0200)건만 조회
          , iv_pgsize      : this.list.listSize
          , iv_page        : this.list.pageNo
        },
        ret => {
          this.list.totalCount = _.get(ret, "data.rs1[0].tot_rows", 0)
          this.list.items      = _.get(ret, "data.rs2", [])
        })
    },
    saveItem() {
      if (this.saveList.length == 0) {
        return ui.alert("정정신청할 사건을 추가해 주세요.")
      }

      const sitem = this.sitem
      // 환불이 필요한 경우
      if (sitem.to_amt < 0) {
        // <!-- 본안(일반-B10100)에서 본안(민사소액-B10600)으로 신청하는 경우 -->
        if (sitem.caseclsf == 'B10100' && sitem.to_caseclsf == 'B10600') {
          if (!this.file1.name && !this.file2.name) {
            return ui.alert("통장사본과 소가 확인 내역을 첨부하시기 바랍니다.")
          }
        }
      }

      ui.confirm('신청하시겠습니까 ?', "신청확인")
        .then(r => r && this.itemUpdate())
    },
    itemUpdate() {
      this.saveList.some((item, i) => {
        this.sitem.viaregdt = ((i == 0) ? '' : this.sitem.viaregdt + '#') + item.viaregdt
        this.sitem.viaseq   = ((i == 0) ? '' : this.sitem.viaseq   + '#') + item.viaseq
      })

      ui.httpPost("/proc_iv/N_VIASTAT_UPD",
      {
        ...this.sitem
        , viastatclsf  : 'CH_CASE'
        , approveclsf  : 'REQ'
        , approvemsg   : ''
        , viastatdt    : ''
        , viastatseq   : ''
        , viastatdtlid : ''
        , to_membclsf  : ''
        , to_membno    : ''
      },
      ret => {
        const {msg, status, sellregdt ,sellseq} = ret.data.rs1[0];
        ui.notify(msg);

        if (status == '0') { // 작업이 정상 완료일때 신청내역 페이지로 이동
           this.$router.push({ path: 'stat_list' })
        }

      })
    }
  }
}
</script>
<style scoped>
  .comment_gray { overflow: hidden; height:105px;}
  .comment_gray.active { height:auto;}
  .mbtn{position: absolute; bottom:0px; right:0px; background: rgba(247, 57, 10, 0.8) ; width: 120px; height: 40px; line-height: 45px; font-weight: 700; text-align: center; color:#fff; cursor: pointer; }

  /*--------------------------------------------------------------------------------------------------------
    순서 ex) 오사용 증표 정정 신청
  ----------------------------------------------------------------------------------------------------------*/
  .tbl01.sum th { width:160px; text-align: center}
  .tbl01.sum td input, .tbl01.sum td select { margin:0 5px 5px 0;}

  @media screen and (max-width:640px){
    .tbl01.sum th {width:90px; }
    .bankinfo_th { height: 200px; display: inline; }
    .infoamt.bankinfo_wrap li { vertical-align: top; display: inline-block; text-align: left; float:none !important; margin:0  !important; width:100%; height:105px;}
    .infoamt.bankinfo_wrap .bankinfo { position: absolute ; vertical-align: top; margin:-72px  0 0 -94px; }
    .infoamt.bankinfo_wrap .bankinfo li { vertical-align: top; display: inline-block; text-align: left; float:none !important; margin:0  !important; width:100%; height:42px;}
    .infoamt.bankinfo_wrap .bankinfo li span { width:94px; display: inline-block; text-align: left;}
    .comment_gray { height:137px;}
    .mbtn { line-height:30px; height:30px; width:80px}
  }

</style>

